import React from 'react';

const StatusBadge = ({ status, text }) => {
  const statusClasses = {
    success: 'bg-green-100 text-green-800 border-green-200',
    danger: 'bg-red-100 text-red-800 border-red-200',
    warning: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    info: 'bg-blue-100 text-blue-800 border-blue-200',
    neutral: 'bg-gray-100 text-gray-800 border-gray-200'
  };

  return (
    <span className={`px-3 py-1 rounded-full text-sm font-medium border ${statusClasses[status] || statusClasses.neutral}`}>
      {text}
    </span>
  );
};

export default StatusBadge;